import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  sendRequest,
  changeQueryParams,
  selectQueryParams
} from 'mt-react-common/common/reducers/list/reducer';
import { t } from 'utils/translates';

import SearchInput from '../../../../components/Common/Inputs/SearchInput';

class TaskOwnersInputs extends Component {
  changeQueryParams = changeParams => {
    this.props.changeQueryParams({ ...changeParams, ...{ page: 1 } });
    this.props.sendRequest();
  };

  render() {
    return (
      <div className="panel panel-default">
        <div className="panel-heading" role="tab" id="panelGroupFilter_h_3">
          <a
            className="dropdown-toggle dropdown-toggle-collapse collapsed"
            role="button"
            data-toggle="collapse"
            href="#panelGroupFilter_c_3"
            aria-expanded="true"
            aria-controls="panelGroupFilter_c_3"
          >
            {t('Заказчики')}
          </a>
        </div>
        <div
          id="panelGroupFilter_c_3"
          className="panel-collapse collapse"
          role="tabpanel"
          aria-labelledby="panelGroupFilter_h_3"
        >
          <div className="panel-body">
            <div className="form-group form-group-sm">
              <label
                className="control-label control-label-light sr-only"
                htmlFor="employerSearch"
              >
                {t('Фильтр по заказчикам')}
              </label>
              <div className="input-group">
                <SearchInput
                  type="search"
                  className="form-control"
                  id="employerSearch"
                  placeholder={t('Фильтр по заказчикам')}
                  onChange={e => {
                    this.changeQueryParams({
                      task_authors: e.target.value
                    });
                  }}
                  value={this.props.selectQueryParams.task_authors}
                />
                <span className="input-group-btn">
                  <button className="btn btn-sm btn-default" type="button">
                    <i className="fa fa-search" />
                  </button>
                </span>
              </div>
            </div>
            <div className="form-group m-b-0">
              <div className="checkbox abc-checkbox">
                <input
                  id="checkbox_blackListEmployer"
                  type="checkbox"
                  className="styled"
                  checked={
                    this.props.selectQueryParams.hide_from_black_list === '1'
                  }
                  onChange={e => {
                    console.log(e.target.checked);
                    this.changeQueryParams({
                      hide_from_black_list: e.target.checked ? '1' : '0'
                    });
                  }}
                />
                <label htmlFor="checkbox_blackListEmployer">
                  {t('Скрыть из черного списка')}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TaskOwnersInputs.propTypes = {
  // CONNECT
  selectQueryParams: PropTypes.shape({
    task_authors: PropTypes.string,
    hide_from_black_list: PropTypes.string
  }).isRequired,
  changeQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  selectQueryParams: selectQueryParams(state, props.listReduceName)
});

const mapDispatchToProps = (dispatch, props) => ({
  sendRequest: () => dispatch(sendRequest(props.listReduceName)),
  changeQueryParams: queryParams =>
    dispatch(changeQueryParams(props.listReduceName, queryParams))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TaskOwnersInputs);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskSearchForm/TaskOwnersInputs/TaskOwnersInputs.js